import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M405.333 170.667c-176.64 0-320 114.773-320 256 0 80.64 46.08 151.893 118.614 198.826l-33.28 99.84 106.666-64c37.974 13.227 79.787 21.334 124.16 21.334A222.72 222.72 0 01384 597.333c0-141.226 133.547-256 298.667-256 8.106 0 16.213 0 23.893 1.28-43.52-99.84-161.28-171.946-301.227-171.946m-128 106.666C300.8 277.333 320 296.533 320 320s-19.2 42.667-42.667 42.667-42.666-19.2-42.666-42.667 19.2-42.667 42.666-42.667m213.334 0c23.466 0 42.666 19.2 42.666 42.667s-19.2 42.667-42.666 42.667S448 343.467 448 320s19.2-42.667 42.667-42.667m192 106.667c-141.227 0-256 95.573-256 213.333s114.773 213.334 256 213.334c28.586 0 55.893-3.414 81.493-10.667l89.173 53.333-26.453-79.786c66.987-38.827 111.787-103.254 111.787-176.214 0-117.76-114.774-213.333-256-213.333m-85.334 106.667c23.467 0 42.667 19.2 42.667 42.666S620.8 576 597.333 576s-42.666-19.2-42.666-42.667 19.2-42.666 42.666-42.666m170.667 0c23.467 0 42.667 19.2 42.667 42.666S791.467 576 768 576s-42.667-19.2-42.667-42.667 19.2-42.666 42.667-42.666z"
});

function SvgWeChatFilled(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "weChat-filled_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChatFilled);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'WeChatFilled';

export default KuFoxIcons;
